import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Icon } from "@phosphor-icons/react";

type ContextMenuProps = React.PropsWithChildren & {
    component: ContextMenuComponent;
    menuItems: { onClick: () => void; label: string, icon: Icon }[];
    componentProps?: object;
};

export type ContextMenuComponent = "div" | "td" | "span" | "circle";

export default function ContextMenu({ children, menuItems, component, componentProps }: ContextMenuProps) {
    const [contextMenu, setContextMenu] = React.useState<{
        mouseX: number;
        mouseY: number;
    } | null>(null);

    const handleContextMenu = (event: React.MouseEvent) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                      mouseX: event.clientX + 2,
                      mouseY: event.clientY - 6,
                  }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                  // Other native context menus might behave different.
                  // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                  null
        );
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    const Component = component;

    return (
        <Component
            onContextMenu={handleContextMenu}
            style={{ cursor: "context-menu" }}
            {...componentProps}
        >
            {children}
            <Menu
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
            >
                {menuItems.map(({ onClick, label, icon: Icon }) => (
                    <MenuItem
                        key={label}
                        onClick={() => {
                            onClick();
                            handleClose();
                        }}
                        className="flex flex-row items-center gap-1"
                    >
                        <Icon />
                        {label}
                    </MenuItem>
                ))}
            </Menu>
        </Component>
    );
}
